import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { isApp } from '../utils';

export const postRnDeeplinkAction = (deeplink) => {
  // TO IMPROVE - Should integrate with EmmaJS
  if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        action: '@CUST/DEEPLINK',
        deeplink,
      }),
    );
    return true;
  }
  return false;
};

export const setNavigationBarTitle = (title = 'AXA') => {
  const reactNativeBridge = window.reactNativeBridge || {} // eslint-disable-line
  EmmaFactory.createInstance().then((e) => {
    e.instance.setNavigationTitle(title);
  });
  if (isApp() && reactNativeBridge.setNavigationBarTitle) {
    return reactNativeBridge.setNavigationBarTitle(title);
  }
  return null;
};

export const hideBackButton = () => {
  EmmaFactory.createInstance().then((p) => {
    if (p.instance.hideBackButton) {
      p.instance.hideBackButton();
    }
  });
};

export const showBackButton = () => {
  // TO IMPROVE - Should integrate with EmmaJS
  if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        action: '@CUST/SHOW_BACK_BUTTON',
      }),
    );
  }
};

export const hideCloseButton = () => {
  // TO IMPROVE - Should integrate with EmmaJS
  if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        action: '@CUST/HIDE_CLOSE_BUTTON',
      }),
    );
  }
};

export const showCloseButton = () => {
  // TO IMPROVE - Should integrate with EmmaJS
  if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        action: '@CUST/SHOW_CLOSE_BUTTON',
      }),
    );
  }
};

export const controlTopbarOverlay = (show) => {
  // TO IMPROVE - Should integrate with EmmaJS
  if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        action: '@CUST/CONTROL_TOPBAR_OVERLAY',
        show,
      }),
    );
  }
};

// this function shall be called on the Constructor level inside the component, instead of componentDidMount
export const controlTopBar = (show) => {
  // TO IMPROVE - Should integrate with EmmaJS
  if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        action: '@CUST/CONTROL_TOPBAR_TRANSPARENT',
        show,
      }),
    );
  }
};

// close page
export const navClose = () => {
  EmmaFactory.createInstance().then((p) => {
    if (p.instance.navClose) {
      p.instance.navClose();
    }
  });
};

// hide topbar
export const hideTopbar = () => {
  EmmaFactory.createInstance().then((p) => {
    if (p.instance.hideTopbar) {
      p.instance.hideTopbar();
    }
  });
};

// show topbar
export const showTopbar = () => {
  EmmaFactory.createInstance().then((p) => {
    if (p.instance.showTopbar) {
      p.instance.showTopbar();
    }
  });
};
